import { HStack, Box, Text } from '@chakra-ui/react'

export const PriceLabel = ({ price, regularPrice = 0 }) => {
  const discount = regularPrice - price

  return (
    <HStack spacing={0}>
      {discount > 0 && (
        <Text fontSize="sm" as="del" color="label.primary" mr={1}>
          <Box as="span" fontWeight="semibold">
            {regularPrice.toLocaleString()}
          </Box>
          <Box as="span" fontSize="2xs">
            円
          </Box>
        </Text>
      )}
      <Text fontSize="2xs" color={discount > 0 || price === 0 ? 'label.accent' : 'label.primary'}>
        <Box as="span" fontSize="sm" fontWeight="semibold">
          {price.toLocaleString()}
        </Box>
        <Box as="span">円</Box>
        {price !== 0 && '（税込）'}
      </Text>
    </HStack>
  )
}
